export const IDEAL_USES_CONST: { title: string; description: string }[] = [
  {
    title: 'Acuerdos laborales y de prestación de servicios',
    description:
      'Formalizar la contratación de un trabajo freelance, consultoría o acuerdo laboral en minutos.',
  },
  {
    title: 'Autorizaciones y consentimientos',
    description:
      'Firmar permisos escolares, autorizaciones de viajes o consentimientos médicos en línea.',
  },
  {
    title: 'Contratos civiles o comerciales simples',
    description:
      'Formalizar acuerdos de compraventa, traspaso de bienes o compromisos privados entre dos partes.',
  },
  {
    title: 'Trámites personales urgentes',
    description:
      'Resolver gestiones legales o administrativas donde se requiera una firma inmediata con respaldo legal.',
  },
  {
    title: 'Acuerdos familiares o personales',
    description:
      'Validar compromisos como préstamos personales, acuerdos de manutención, herencias o particiones.',
  },
]

export const IDEAL_USES_NUNA_CORP_CONST: { title: string; description: string }[] = [
  {
    title: `Finanzas y Banca`,
    description: `Apertura inmediata de cuentas.
Autorización ágil de créditos y préstamos.
Validación de identidad en segundos.`,
  },
  {
    title: `Seguros`,
    description: `Firma digital de pólizas al instante.
Gestión rápida de reclamos y autorizaciones.
Eliminación del papeleo físico en procesos clave.`,
  },
  {
    title: `Telecomunicaciones`,
    description: `Contratación inmediata de planes y servicios.
Renovación de contratos sin trámites presenciales.
Reducción de tiempos de espera para clientes.`,
  },
  {
    title: `Salud`,
    description: `Firma segura de consentimientos informados en línea.
Registro digital de autorizaciones médicas.
Gestión documental de pacientes más eficiente.`,
  },
  {
    title: `Sector Empresarial`,
    description: `Aprobación rápida de contratos laborales y comerciales.
Validación de acuerdos internos y externos en segundos.
Procesos más ágiles, digitales y confiables.`,
  },
]
